export default "__VITE_ASSET__DjooYevo__"